const translations = {
    title: 'Account Details'
};

export default translations;
